// extracted by mini-css-extract-plugin
export default {"tooltip-label":"g__tooltip-label--qHon4","tooltip-icon":"g__tooltip-icon--kPwRw","lost-reserve-not-met-content":"g__lost-reserve-not-met-content--QtGqG"};